export default __webpack_public_path__ + "static/media/eye-hide.7efd9ca4.svg";